<div class="p-24 p-b-0">
  <div class="row">
    <div class="col-8">
      <mat-form-field
        appearance="outline"
        color="primary"
        class="hide-hint w-100"
      >
        <input matInput placeholder="Search here" [(ngModel)]="searchText" (change)="searchDeviceFromSerialNumber()"/>
      </mat-form-field>
    </div>
    <div class="col-2 d-flex justify-content-end">
      <button mat-icon-button aria-label="Buscar dispositivo" mat-dialog-close class="d-flex justify-content-center" (click)="searchDeviceFromSerialNumber()"
      >
        <i-tabler name="search" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>
    <div class="col-2 d-flex justify-content-end">
      <button
        mat-icon-button
        mat-dialog-close
        class="d-flex justify-content-center"
      >
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>
  </div>
</div>
